export const TERMS_META_DESCRIPTION =
	'Terms & Conditions for AngelOne Fincap Private Limited—RBI-registered NBFC offering loan against securities (LAS), loans against stocks and ETFs, and loans against mutual funds (LAMF).';
